export const PLAN_TYPES = [
    {
        name: 'activity',
        id: 'activity'
    },
    {
        name: 'accommodation',
        id: 'accommodation'
    },
    {
        name: 'transfer',
        id: 'transfer'
    },
    {
        name: 'custom',
        id: 'custom'
    }
];
